import { EditOutlined } from '@icon';
import { Table } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import type { Column } from 'react-table';
import { IWorkspaceDetail, IWorkspaceWorker } from 'types/workspace.types';

interface UseTableParams {
  onEditClick: (record: IWorkspaceWorker) => void;
}

export function useTableColumns(params: UseTableParams) {
  const { formatMessage } = useIntl();
  const { onEditClick } = params;

  return React.useMemo<Column<IWorkspaceDetail['workers'][number]>[]>(
    () => [
      {
        id: 'name',
        Header: 'Zamestnanec',
        Cell: ({ row }: any) => <>{`${row.original.firstName} ${row.original.lastName}`}</>,
      },
      {
        id: 'role',
        Header: 'Rola',
        Cell: ({ row }: any) => {
          return <>{formatMessage({ id: `business_staff_role_${row.original.role.name}` })}</>;
        },
      },
      {
        id: 'hasEVisit',
        Header: 'E-termín',
        Cell: ({ row }: any) => {
          return <>{row.original.hasEVisit ? 'Áno' : 'Nie'}</>;
        },
      },
      {
        id: 'actions',
        Header: '',
        Cell: ({ row }: any) => {
          return (
            <Table.Actions
              items={[
                {
                  key: 'edit',
                  label: 'Upraviť',
                  Icon: EditOutlined,
                  onClick: () => {
                    onEditClick(row.original);
                  },
                },
              ]}
            />
          );
        },
      },
    ],
    [],
  );
}
